export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13282.478e00fc.jpg";